import { INeoAction } from './../Actions.interface';
import { REQUEST_ACTIONS, STATUS } from '../../Constants/Actions.constants';
import { isActionValid } from '../../Helpers/Reducer.helper';
import { IEvent } from '../../Models/DTO/Event.model';

const useValidActions = isActionValid([
  REQUEST_ACTIONS.GET_EVENT_LIST,
  REQUEST_ACTIONS.SINGLE_EVENT,
  REQUEST_ACTIONS.UPDATE_EVENT,
  REQUEST_ACTIONS.UPDATE_EVENT_LIST,
  REQUEST_ACTIONS.CREATE_EVENT,
  REQUEST_ACTIONS.DELETE_EVENTGROUP,
]);

const INITIAL_STATE: { [key: string]: IEvent } = {};

const mapEventsToId = (eventList: IEvent[]) =>
  eventList.reduce((map, event) => {
    if (event.archived) {
      return map;
    }
    return {
      ...map,
      [event.id]: event,
    };
  }, {});

export default (state = INITIAL_STATE, action: INeoAction): { [key: string]: IEvent } => {
  const { status, name = '', payload } = action;

  const actionValid = useValidActions(name);
  if (actionValid && status === STATUS.SUCCESS) {
    switch (name) {
      case REQUEST_ACTIONS.UPDATE_EVENT:
      case REQUEST_ACTIONS.CREATE_EVENT:
        return { ...state, [payload.id]: payload };
      case REQUEST_ACTIONS.UPDATE_EVENT_LIST: {
        const newState = { ...state };
        payload.forEach((event: IEvent) => event.id in state && (newState[event.id] = event));

        return newState;
      }
      case REQUEST_ACTIONS.DELETE_EVENTGROUP: {
        const newState = {} as typeof state;
        for (const eventId in state) {
          if (state[eventId]?.eventGroupId !== payload.id) {
            newState[eventId] = state[eventId];
          }
        }
        return newState;
      }
      default:
        return mapEventsToId(Array.isArray(payload) ? payload : [payload]);
    }
  }
  return state;
};
